import React from "react";
import styled from "styled-components";
import { Box, Button, Paper, Stack } from "@mui/material";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import CalculateIcon from "@mui/icons-material/Calculate";
import request from "src/utils/request";
import Link from "@mui/material/Link";
import { ToastContext } from "src/components/providers/toast-provider";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";

const CustomPaper = styled(Paper)`
    border-radius: 14px;
    padding: 28px;
    margin-top: 32px;
    width: 100%;
`;
const GenericModelNotification = ({ isTeam, isOrg, selectedId, isDemo }) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const { activeIntegrations } = useActiveIntegrations();

    const isGitIntegrated =
        activeIntegrations &&
        activeIntegrations.data &&
        (activeIntegrations.data.integrations.find((int) => int.name === "gitlab")?.connected ||
            activeIntegrations.data.integrations.find((int) => int.name === "gitlabSelfManaged")
                ?.connected ||
            activeIntegrations.data.integrations.find((int) => int.name === "github")?.connected);

    const requestCustomModel = async () => {
        if (isTeam) {
            await request(`/api/data/causal`, {
                method: "POST",
                body: JSON.stringify({
                    id: selectedId,
                    entityType: "team",
                    analysisType: "lead_time",
                }),
            });
        } else if (isOrg) {
            await request(`/api/data/causal`, {
                method: "POST",
                body: JSON.stringify({
                    id: selectedId,
                    entityType: "org",
                    analysisType: "lead_time",
                }),
            });
        } else {
            await request(`/api/data/causal`, {
                method: "POST",
                body: JSON.stringify({
                    id: selectedId,
                    entityType: "user",
                    analysisType: "lead_time",
                }),
            });
        }
        setMessage(`Your custom model calculation has started. We'll notify you once it's ready!`);
        setSeverity("success");
        setIsToastTriggered(true);
    };
    const handleRequestCustomModel = async () => {
        try {
            requestCustomModel();
        } catch (e) {
            setMessage(`Error occurred. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    if (activeIntegrations.status !== "SUCCESS") return null;
    return (
        <CustomPaper>
            <Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box
                        style={{
                            backgroundColor: "#303030",
                            borderRadius: "46px",
                            height: "46px",
                            width: "46px",
                        }}
                    >
                        <ReportGmailerrorredIcon style={{ margin: "11px" }} />
                    </Box>
                    {(activeIntegrations.status === "SUCCESS" && isGitIntegrated) || isDemo ? (
                        <p>
                            You are currently viewing the general data model, generated from the
                            entirety of our user data. Click on the button to request{" "}
                            <Link
                                href="https://docs.adadot.com/Data/Causal/custom_graph/"
                                target="_blank"
                            >
                                {" "}
                                generation of your own!{" "}
                            </Link>
                        </p>
                    ) : (
                        <p>
                            You are currently viewing the general data model,{" "}
                            <Link to="/integrations">integrate</Link> with at least one Version
                            Control tool to gain the ability to generate you{" "}
                            <Link
                                href="https://docs.adadot.com/Data/Causal/custom_graph/"
                                target="_blank"
                            >
                                personal data model
                            </Link>
                        </p>
                    )}
                </Stack>
                <Button
                    variant="contained"
                    disabled={!isGitIntegrated}
                    onClick={handleRequestCustomModel}
                    startIcon={<CalculateIcon />}
                    style={{ width: "285px" }}
                >
                    Request custom model
                </Button>
            </Stack>
        </CustomPaper>
    );
};

export default GenericModelNotification;
